import {
  ADOBE_PREVIOUS_PAGE_NAME_KEY,
  ADOBE_SAVED_ITEM_COUNT_KEY,
  ADOBE_SORT_BY_KEY,
  ADOBE_SHARE_ID_KEY,
  ADOBE_BOARD_ID_KEY,
  ADOBE_BOARD_ERROR_KEY,
  ADOBE_PRODUCTS_KEY,
  ADOBE_SIMILAR_ITEMS_COUNT_KEY,
  ADOBE_SIMILAR_ITEMS_IDS_KEY,
  ADOBE_EVENTS_KEY,
  ADOBE_SAVED_ITEMS_RECEIVED_DTC_AND_AFS_ITEMS_KEY
} from "../constants";
import {
  ITEMS_TYPE_CUSTOMER_ITEMS,
  ITEMS_TYPE_SHARED_BOARD,
  ITEMS_TYPE_SIMILAR
} from "../../../constants";
import mapToEventsWithValues from "../mapToEventsWithValues";

const mapToAppMeasurementInstance = ({
  trackPage: {
    previousPageName,
    savedItemCount,
    error,
    events,
    similarItemsCount,
    similarItemsIds,
    productsString,
    dtcAndAfsCountString
  },
  sortBy,
  itemsType,
  boardId,
  shareId
}) => {
  const mappedEvents = events ? mapToEventsWithValues(events) : undefined;

  return {
    [ADOBE_PREVIOUS_PAGE_NAME_KEY]: previousPageName,
    ...(itemsType === ITEMS_TYPE_CUSTOMER_ITEMS
      ? {
          [ADOBE_SAVED_ITEM_COUNT_KEY]: savedItemCount,
          [ADOBE_SORT_BY_KEY]: sortBy,
          [ADOBE_PRODUCTS_KEY]: productsString,
          [ADOBE_EVENTS_KEY]: mappedEvents,
          [ADOBE_SAVED_ITEMS_RECEIVED_DTC_AND_AFS_ITEMS_KEY]:
            dtcAndAfsCountString
        }
      : {}),
    ...(itemsType === ITEMS_TYPE_SHARED_BOARD
      ? {
          [ADOBE_SAVED_ITEM_COUNT_KEY]: savedItemCount,
          [ADOBE_SORT_BY_KEY]: sortBy,
          [ADOBE_BOARD_ID_KEY]: boardId,
          [ADOBE_SHARE_ID_KEY]: shareId,
          [ADOBE_BOARD_ERROR_KEY]: error,
          [ADOBE_EVENTS_KEY]: mappedEvents
        }
      : {}),
    ...(itemsType === ITEMS_TYPE_SIMILAR
      ? {
          [ADOBE_SIMILAR_ITEMS_COUNT_KEY]: similarItemsCount,
          [ADOBE_SIMILAR_ITEMS_IDS_KEY]: similarItemsIds,
          [ADOBE_EVENTS_KEY]: mappedEvents
        }
      : {})
  };
};

export default mapToAppMeasurementInstance;
